import type { ComponentType, ImgHTMLAttributes } from "react";
import { createContext, useContext } from "react";

export type ImageWrapperProps = ImgHTMLAttributes<HTMLImageElement>;

export const ImageBehaviourContext = createContext<ComponentType<ImageWrapperProps> | null>(null);

export const useImage = () => {
  return useContext(ImageBehaviourContext);
};
